import { render, staticRenderFns } from "./GalleryPrice.vue?vue&type=template&id=3b5a5ddd&"
import script from "./GalleryPrice.vue?vue&type=script&lang=js&"
export * from "./GalleryPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports